<div class="scad-body">
    <app-flow-header></app-flow-header>
    <div class="scad-body__container scad-body--white-removed">
        <app-auto-ml-input *ngIf="!autoMlService.isInput"></app-auto-ml-input>
        <app-auto-ml-entry *ngIf="autoMlService.iterationSet[0].target_columns.length ===0 && autoMlService.isInput"></app-auto-ml-entry>
        <app-auto-ml-results *ngIf="autoMlService.iterationSet[0].target_columns.length >0 && !autoMlService.isSatisfy"></app-auto-ml-results> 
        <!-- <app-auto-ml-results ></app-auto-ml-results>  -->
        <app-auto-ml-scenario *ngIf="autoMlService.isSatisfy"></app-auto-ml-scenario>
    </div>
</div>
<!-- <app-automl-login></app-automl-login> -->